module.exports = __webpack_public_path__ + "img/mobile_chrome_bar.8546f137.png";